import { SQLITE_TABLE_PUSH_LOGS } from '@1bill-app/constants';
import { SQLiteService } from '@1bill-app/services/sqlite/sqlite.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { NGXLogger } from 'ngx-logger';


@Component({
  selector: 'app-push-log-details',
  templateUrl: './push-log-details.page.html',
  styleUrls: ['./push-log-details.page.scss'],
})
export class PushLogDetailsPage implements OnInit {
  id: string;
  logDetails: any;

  constructor(
    private route: ActivatedRoute,
    private sqlite: SQLiteService,
    private logger: NGXLogger,
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.loadAppLog(this.id);
  }

  async loadAppLog(id: string) {
    this.logger.info('Load push log details', { id });
    const statement = `SELECT * FROM ${SQLITE_TABLE_PUSH_LOGS} WHERE id=?`;
    const { values } = await this.sqlite.query({ statement, values: [id] });
    this.logDetails = values[0];
    if (this.logDetails.data) {
      this.logDetails.data = JSON.parse(this.logDetails.data);
    }
  }

  async share() {
    this.logger.info('Share push log details.');
    try {
      const fileName = this.logDetails.id + '.json';
      // write file
      const result = await Filesystem.writeFile({
        path: fileName,
        data: JSON.stringify(this.logDetails),
        directory: Directory.Cache,
        encoding: Encoding.UTF8,
      });
      // share file
      await Share.share({
        title: fileName,
        url: result.uri,
      });
    } catch (err) {
      this.logger.error('Share push log details error.', err);
    }
  }
}
